import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, MapPin, Clock, Mail, Facebook, Instagram, ShieldCheck, ChevronRight } from 'lucide-react';
export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-317">
      {/* Top utility bar */}
      <div className="hidden md:block bg-brand-black text-zinc-300 text-xs border-b border-zinc-800" data-id="element-318">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between" data-id="element-319">
          <div className="flex items-center gap-6" data-id="element-320">
            <span className="flex items-center gap-1.5" data-id="element-321">
              <MapPin className="w-3.5 h-3.5 text-brand-red" data-id="element-322" /> Serving Central
              Valley, CA
            </span>
            <span className="flex items-center gap-1.5" data-id="element-323">
              <Clock className="w-3.5 h-3.5 text-brand-red" data-id="element-324" /> Open 7 Days •
              7:00 AM – 7:00 PM
            </span>
            <span className="flex items-center gap-1.5" data-id="element-325">
              <ShieldCheck className="w-3.5 h-3.5 text-brand-red" data-id="element-326" /> Licensed &
              Insured
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-327">
            <a href="mailto:Jezjunksolution@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-328">
              <Mail className="w-3.5 h-3.5 text-brand-red" data-id="element-329" />
              Jezjunksolution@gmail.com
            </a>
            <span className="text-zinc-500" data-id="element-330">|</span>
            <a href="https://www.facebook.com/profile.php?id=61573603221493" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white transition-colors" data-id="element-331">
              <Facebook className="w-3.5 h-3.5" data-id="element-332" />
            </a>
            <a href="https://instagram.com/jezjunkaway" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors" data-id="element-333">
              <Instagram className="w-3.5 h-3.5" data-id="element-334" />
            </a>
            <a href="https://tiktok.com/@jezjunkawaysolutions" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-white transition-colors" data-id="element-335">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5" data-id="element-336">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" data-id="element-337" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className={`bg-white transition-shadow ${scrolled ? 'shadow-lg' : 'border-b border-zinc-200'}`} data-id="element-338">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 md:h-28 flex items-center justify-between" data-id="element-339">
          <a href="#" className="flex items-center gap-3" data-id="element-340">
            <img src="https://cdn.magicpatterns.com/uploads/vWKqmdVYNC9wCEg3vWukxp/Photoroom_20260602_081134.png" alt="Jez Junk Away Solution" className="h-20 md:h-24 w-auto object-contain drop-shadow-sm" data-id="element-341" />
          </a>

          <nav className="hidden md:flex items-center gap-8" data-id="element-342">
            {[{
            label: 'Services',
            href: '#services'
          }, {
            label: 'Gallery',
            href: '#gallery'
          }, {
            label: 'Process',
            href: '#process'
          }, {
            label: 'Areas',
            href: '#areas'
          }, {
            label: 'Reviews',
            href: '#reviews'
          }, {
            label: 'FAQ',
            href: '#faq'
          }].map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-zinc-700 hover:text-brand-red transition-colors relative group" data-id="element-343">
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-red group-hover:w-full transition-all duration-300" data-id="element-344"></span>
              </a>)}
          </nav>

          <div className="hidden md:flex items-center gap-3" data-id="element-345">
            <div className="text-right" data-id="element-346">
              <p className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold" data-id="element-347">
                24/7 Hotline
              </p>
              <a href="tel:+15597709442" className="font-oswald text-lg font-bold text-brand-black hover:text-brand-red transition-colors leading-none" data-id="element-348">
                (559) 770-9442
              </a>
            </div>
            <a href="tel:+15597709442" className="flex items-center gap-2 bg-brand-red hover:bg-brand-darkred text-white px-5 py-3 rounded-sm font-bold text-sm transition-all uppercase tracking-wide shadow-md hover:shadow-lg" data-id="element-349">
              <Phone className="w-4 h-4" data-id="element-350" />
              Free Quote
            </a>
          </div>

          <button className="md:hidden p-2 text-zinc-900" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-351">
            {isOpen ? <X className="w-6 h-6" data-id="element-352" /> : <Menu className="w-6 h-6" data-id="element-353" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white border-b border-zinc-200 px-4 py-4 flex flex-col gap-1 shadow-lg" data-id="element-354">
          {[{
        label: 'Services',
        href: '#services'
      }, {
        label: 'Gallery',
        href: '#gallery'
      }, {
        label: 'Process',
        href: '#process'
      }, {
        label: 'Areas',
        href: '#areas'
      }, {
        label: 'Reviews',
        href: '#reviews'
      }, {
        label: 'FAQ',
        href: '#faq'
      }].map(item => <a key={item.href} href={item.href} onClick={() => setIsOpen(false)} className="flex items-center justify-between py-3 px-2 border-b border-zinc-100 text-base font-semibold text-zinc-900" data-id="element-355">
              {item.label}
              <ChevronRight className="w-4 h-4 text-zinc-400" data-id="element-356" />
            </a>)}
          <a href="tel:+15597709442" className="flex items-center justify-center gap-2 bg-brand-red text-white px-6 py-4 rounded-sm font-bold w-full mt-4 uppercase" data-id="element-357">
            <Phone className="w-5 h-5" data-id="element-358" />
            Call (559) 770-9442
          </a>
        </div>}
    </header>;
};
export const Footer = () => <footer className="bg-brand-black text-white border-t-4 border-brand-red" data-id="element-359">
    {/* Top CTA strip */}
    <div className="bg-brand-red" data-id="element-360"></div>

    {/* Main footer */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-361">
      <div className="flex flex-col items-center text-center space-y-4" data-id="element-362">
        <img src="https://cdn.magicpatterns.com/uploads/vWKqmdVYNC9wCEg3vWukxp/Photoroom_20260602_081134.png" alt="Jez Junk Away Solution" className="h-28 md:h-32 w-auto object-contain drop-shadow-lg" data-id="element-363" />
        <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-364">
          The Central Valley's full-service junk and debris removal team. We
          remove what nobody else will — fast, professionally, and at a price
          that makes sense.
        </p>
        <div className="flex flex-col gap-2 pt-2 text-sm w-full" data-id="element-365">
          <a href="tel:+15597709442" className="flex items-center justify-center gap-2 text-zinc-300 hover:text-brand-red transition-colors font-semibold" data-id="element-366">
            <Phone className="w-4 h-4 text-brand-red" data-id="element-367" />
            (559) 770-9442
          </a>
          <a href="mailto:Jezjunksolution@gmail.com" className="flex items-center justify-center gap-2 text-zinc-300 hover:text-brand-red transition-colors font-semibold break-all" data-id="element-368">
            <Mail className="w-4 h-4 text-brand-red" data-id="element-369" />
            Jezjunksolution@gmail.com
          </a>
          <div className="flex items-start justify-center gap-2 text-zinc-300 font-semibold" data-id="element-370">
            <Clock className="w-4 h-4 text-brand-red mt-0.5 shrink-0" data-id="element-371" />
            <div className="text-center leading-tight" data-id="element-372">
              <p data-id="element-373">Open 7 Days a Week</p>
              <p className="text-zinc-400 text-xs font-normal" data-id="element-374">
                7:00 AM – 7:00 PM
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-3 pt-2 justify-center" data-id="element-375">
          <a href="https://www.facebook.com/profile.php?id=61573603221493" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-376">
            <Facebook className="w-4 h-4" data-id="element-377" />
          </a>
          <a href="https://instagram.com/jezjunkaway" target="_blank" rel="noopener noreferrer" aria-label="Instagram @jezjunkaway" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-378">
            <Instagram className="w-4 h-4" data-id="element-379" />
          </a>
          <a href="https://tiktok.com/@jezjunkawaysolutions" target="_blank" rel="noopener noreferrer" aria-label="TikTok @jezjunkawaysolutions" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-380">
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" data-id="element-381">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" data-id="element-382" />
            </svg>
          </a>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-zinc-800" data-id="element-383">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-zinc-500" data-id="element-384">
        <p data-id="element-385">
          © {new Date().getFullYear()} Jez Junk Away Solution. All rights
          reserved.
        </p>
        <p className="font-oswald uppercase tracking-wider text-zinc-400" data-id="element-386">
          "We Remove Anything. From Anywhere. No Excuses."
        </p>
        <div className="flex gap-4" data-id="element-387">
          <a href="#" className="hover:text-white" data-id="element-388">
            Privacy
          </a>
          <a href="#" className="hover:text-white" data-id="element-389">
            Terms
          </a>
        </div>
      </div>
    </div>
  </footer>;